import React from "react"
import Paper from '@material-ui/core/Paper'
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction"
import Edit from '@material-ui/icons/Edit'
import { useAwaitingApproval, setToReview } from '../redux/plan'
import { setSelectedModule } from '../redux/navigation'
import { theme } from "../theme";

const Approval = () => {
  const {colors} = theme
  const items = useAwaitingApproval()
  const doApproval = (data) => {
    setToReview(data)
    setSelectedModule('ApprovalEditor')
  }
  const aqua = { color: colors.secondary }

  return (
    <Paper style={{ margin:30 }}>
      {items.length>0?
      <List>
          {items.map((x) => (
              <ListItem key={x._id} onClick={()=>doApproval(x) }>
                <ListItemText primary={x.writer ? x.writer +' - '+ x.title : 'Writer not specified - '+ x.title } />
                <ListItemSecondaryAction>
                  <ListItemIcon onClick={()=>doApproval(x) } className="drag-handle">
                    <Edit style={aqua}/>
                  </ListItemIcon>
                </ListItemSecondaryAction>
              </ListItem>
          ))}
      </List>:
      <h1>There are no SOP approval requests</h1>
      }
    </Paper>
  )
}
export default Approval